// axios({
//     url: "http://127.0.0.1:8086/xueli/xueli/xlstudent/xiaoshou",
//     params:{
//         onecount:'4'
//     }.then(result => {
//         const obj = result.data.data
//         Object.keys(obj).forEach(key=>{
//             if (key === 'cell'){
//                 document.querySelector('.${key}').value = obj[key]
//             }
//         })
//     })
// })

import {
    ApiUtils,
    _axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';

const api = {
    list: (params, successCallback, failCallback, exceptionCallback) => {
        ApiUtils.getLoadingAjax(constant.serverUrl + "/xueli/xlstudent/xiaoshou", params, successCallback, failCallback, exceptionCallback);
    }
}

export default api;